import { Typography } from 'antd';
import { TextProps } from 'antd/lib/typography/Text';
import { FC } from 'react';

const TextAtom: FC<TextProps> = ({ children, ...prop }) => {
  return <Typography.Text {...prop}>{children}</Typography.Text>;
};

export default TextAtom;
